"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AmountTableData = void 0;
var _definitions = require("@ppay/definitions");
var _react = _interopRequireDefault(require("react"));
var _interfaces = require("../../interfaces");
var _ticker = require("../ticker");
var _ui = require("../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var AmountTableData = function AmountTableData(_ref) {
  var value = _ref.value,
    ticker = _ref.ticker,
    target = _ref.target,
    convertedValue = _ref.convertedValue,
    type = _ref.type,
    exchangePrice = _ref.exchangePrice,
    className = _ref.className;
  return target ? /*#__PURE__*/_react.default.createElement(_ui.AmountTableData, {
    value: function value() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " \u2192 ", /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
        value: target.amount,
        ticker: target.ticker
      }), " ", target.ticker);
    },
    ticker: ticker,
    convertedValue: function convertedValue() {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "(", /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
        value: 1,
        ticker: exchangePrice.pair[0]
      }), " ", exchangePrice.pair[0], ' ', "= ", /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
        value: exchangePrice.value,
        ticker: exchangePrice.pair[1]
      }), ' ', exchangePrice.pair[1], ")");
    },
    convertedTicker: _definitions.Ticker.USD,
    className: className
  }) : /*#__PURE__*/_react.default.createElement(_ui.AmountTableData, {
    value: value,
    ticker: ticker,
    convertedValue: convertedValue,
    convertedTicker: _definitions.Ticker.USD,
    positive: type && type === _interfaces.TransactionType.DEPOSIT,
    className: className
  });
};
exports.AmountTableData = AmountTableData;